/**
 * The ONE "confirm password" check, shared by every WagePro screen where a
 * person chooses a new password: the employer sign-up screen
 * (`wagepro_signup_logic.ts`) and the employee invite set-password step
 * (`invite_accept_logic.ts`). Both import this — never re-implement it.
 *
 * Exact comparison: no trimming, no case folding — a password with a stray
 * space or a different case is a different password, and the confirmation
 * exists precisely to catch that typo before the account is created with it.
 *
 * Client-side only. The confirmation value is never sent to the API.
 */
export function passwordConfirmationMatches(
  password: string,
  confirmation: string,
): boolean {
  return password === confirmation;
}
